<template>
  <div v-if="isLoading">
    <div class="text-center text-danger screen-center">
      <div class="align-middle spinner-bubble spinner-bubble-danger mr-5"></div>
      <strong>Cargando...</strong>
    </div>
  </div>
  <div v-else>
    <div class="row mb-3">
      <div class="col-sm-12">
        <div class="form-group row" style="margin: auto;">
          <label class="checkbox checkbox-success mr-4">
            <input
              id="activar-insumo"
              type="checkbox"
              v-model="activar"
              @change="saveActivarDesactivarUI"
              :disabled="isDisabled"
            />
            <span>Activar</span>
            <span class="checkmark"></span>
          </label>
          <div class="col-sm-1">
            <input
              ref="fileInput"
              type="file"
              class="form-control"
              accept=".xlsx,.xls,.csv"
              @change="onFileSelected"
              style="display: none;"
            />
            <button class="btn btn-secondary py-1" @click="$refs.fileInput.click()">
              Importar
            </button>
          </div>
          <div class="col-lg-2 text-center">
            <span v-if="archivoSeleccionado" class="">
              {{ archivoSeleccionado.name }}
            </span>
          </div>
          <div class="col-sm-2 ml-auto">
            <multiselect
              v-model="opcionSeleccionada"
              :options="listaOpciones"
              placeholder="Seleccionar servicio..."
              label="nombre"
              track-by="id"
              select-label=""
              deselect-label="X"
              class="multiselect-servicios"
            >
            </multiselect>
          </div>
          <div class="col-sm-3">
            <multiselect
              v-model="ordenSeleccionada"
              :options="listaOrdenOpciones"
              placeholder="Seleccionar orden..."
              label="descripcion"
              track-by="id"
              select-label=""
              deselect-label="X"
              class="multiselect-orden"
            >
            </multiselect>
          </div>
          <div class="col-sm-2">
            <button class="btn btn-success py-1 btn-block" @click="guardar">
              Agregar
            </button>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="row" style="margin: 3%;" v-if="activar">
      <div class="col-sm-12">
        <b-table
          class="table table-striped table-hover"
          :fields="fields"
          :items="listaTabla"
          :busy="isLoading"
        >
          <template #cell(asignacion_orden_trabajo)="row">
            <button
              v-if="row.item.tipo_modulo_id === tipoOrdenTrabajo"
              class="btn py-1"
              :class="row.item.asignacion_orden_trabajo > 0 ? 'btn-success' : 'btn-gray'"
              @click="abrirModalAsginacionOT(row.item)"
            >
              {{ nombreButtonAsignacion(row.item) }}
            </button>
          </template>
          <template #cell(acciones)="row">
            <i class="nav-icon i-Close-Window font-weight-bold text-danger" style="cursor: pointer"
              @click="eliminarOpcion(row.item)"></i>
          </template>
          <template #cell(producto)="row">
            <button
              class="btn py-1"
              :class="row.item.cantidad_producto > 0 ? 'btn-success' : 'btn-gray'"
              @click="abrirModal(row.item)"
            >
              Agregar
            </button>
          </template>
          <template #cell(estado)="row">
            <button class="btn py-1" :class="row.item.estado? 'btn-success': 'btn-danger'">
              {{row.item.estado? 'Activo':'Pausa'}}
            </button>
          </template>
        </b-table>
      </div>
    </div>

    <!-- Sección Cuenta Contable -->
    <div class="row mt-3" v-if="activar">
      <div class="col-sm-12">
        <div class="form-group row" style="margin: auto;">
          <label>Cuenta Contable:</label>
          <div class="col-sm-3">
            <multiselect
              v-model="cuentaSelected"
              :options="cuentaContables"
              placeholder=""
              label="nombre"
              track-by="id"
              select-label=""
              deselect-label="X"
              class="multiselect-cuenta"
            >
            </multiselect>
          </div>
          <div class="col-sm-2">
              <b-input-group-append>
                <button
                  class="btn btn-light px-2"
                  @click="guardarCuentaContable"
                  :disabled="!cuentaSelected"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    fill="currentColor"
                    class="bi bi-floppy"
                    viewBox="0 0 16 16"
                  >
                    <path d="M11 2H9v3h2z"/>
                    <path d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16
                      2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0
                      0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5
                      0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0
                      0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5
                      7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0
                      .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5
                      0 0 0-.5.5z"
                    />
                  </svg>
                </button>
              </b-input-group-append>
          </div>
          <div class="col-sm-6">
            <!-- Espacio para futuras funcionalidades -->
          </div>
        </div>
      </div>
    </div>

    <vincularProducto
      ref="vincularProducto"
      :insumo-id="productoSeleccionado ? productoSeleccionado.id : null"
      :servicio-data="servicioData"
      @confirmado="onProductosVinculados"
    />
    <TheModalAsignacionOT
    :itemInsumo="productoSeleccionado"
    @guardarAsignacion="onModalAsignacion"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import axios from '@/modules/common/axiosERP';
import { util } from '@/plugins/util';
import Multiselect from 'vue-multiselect';
import { FUNCIONALIDADES } from '@/utils/globalConventions';
import vincularProducto from './vincularProducto.vue';
import TheModalAsignacionOT from './TheModalAsignacionOT.vue';

export default {
  name: 'TheInsumo',
  props: {
  },
  components: {
    Multiselect,
    vincularProducto,
    TheModalAsignacionOT,
  },
  data() {
    return {
      isDisabled: true,
      activar: true,
      fields: [
        {
          key: 'acciones', label: '', thClass: 'py-1 pr-1', class: 'text-center', thStyle: { width: '8%' },
        },
        {
          key: 'numero', label: 'N°', class: 'text-center', thStyle: { width: '5%' },
        },
        {
          key: 'servicio', label: 'Nombre', class: 'text-center', thStyle: { width: '31%' },
        },
        {
          key: 'fecha_creacion',
          label: this.ordenSeleccionada ? 'Tipo' : 'F/Creación',
          class: 'text-center',
          thStyle: { width: '15%' },
        },
        {
          key: 'funcionalidad', label: 'Tipo', class: 'text-center', thStyle: { width: '10%' },
        },
        {
          key: 'asignacion_orden_trabajo', label: 'O.T Grupal', class: 'text-center', thStyle: { width: '27%' },
        },
        {
          key: 'cantidad_usado', label: 'Cantidad usado', class: 'text-center', thStyle: { width: '13%' },
        },
        {
          key: 'producto', label: 'Producto', class: 'text-center', thStyle: { width: '9%' },
        },
        {
          key: 'estado', label: 'Estado', class: 'text-center', thStyle: { width: '9%' },
        },
      ],
      listaTabla: [],
      listaOpciones: [],
      opcionSeleccionada: null,
      productoSeleccionado: null,
      listaOrdenOpciones: [],
      ordenSeleccionada: null,
      cuentaContables: [],
      cuentaSelected: null,
      archivoSeleccionado: null,
      isLoading: false,
      servicioData: [],
      texto_activacion: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async abrirModal(producto) {
      try {
        this.productoSeleccionado = producto;

        // Primero cargar la lista de productos disponibles
        if (this.$refs.vincularProducto) {
          await this.$refs.vincularProducto.cargarProductosDisponibles();
        }

        // Luego cargar datos del servicio complementario
        const response = await axios.get(`/clinic/servicio_complementario/show/${producto.id}`);
        const servicioData = response.data.data;

        // Establecer los datos del servicio como prop
        this.servicioData = servicioData.productos || [];

        // Pasar los datos al componente vincularProducto
        if (this.$refs.vincularProducto) {
          this.$refs.vincularProducto.cargarDatosServicio(servicioData);
        }

        this.$bvModal.show('modal-vincular-producto');
      } catch (error) {
        util.showNotify(
          error.response?.data?.message || 'Error al cargar datos del servicio',
          'error',
        );
      }
    },
    onProductosVinculados() {
      // Actualizar específicamente el insumo que se modificó
      if (this.productoSeleccionado) {
        // Buscar el insumo en la lista y actualizar su cantidad_producto
        const insumoIndex = this.listaTabla.findIndex(
          (item) => item.id === this.productoSeleccionado.id,
        );
        if (insumoIndex !== -1) {
          // Hacer una llamada para obtener los datos actualizados del insumo
          this.getData();
        }
      }
      // Limpiar la selección
      this.productoSeleccionado = null;
    },
    async getData() {
      this.isLoading = true;
      this.isDisabled = true;
      try {
        const response = await axios.get(
          '/clinic/servicio_complementario/insumos',
        );
        this.cuentaContables = response.data.data.cuenta_contables_insumos;
        this.listaOpciones = response.data.data.all_servicios;
        this.listaOrdenOpciones = response.data.data.modulos_in_insumos;
        this.listaTabla = response.data.data.insumos;
        this.texto_activacion = response.data.data.texto_activacion;
        this.cuentaSelected = this.texto_activacion ? this.cuentaContables.find((item) => item.id === this.texto_activacion.cuenta_contable_insumo_id) : null;
        this.opciones = response.data.data.categorias_servicios_complementarios;
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      } finally {
        this.isDisabled = false;
        this.isLoading = false;
      }
    },
    async guardar() {
      try {
        if (this.validar()) {
          const servicioId = this.opcionSeleccionada.id;
          const moduloId = this.ordenSeleccionada.id;

          // Validar duplicado en la tabla antes de guardar
          if (this.existeEnTabla(servicioId, moduloId)) {
            util.showNotify('El servicio ya existe para la orden seleccionada', 'warn');
            return;
          }

          const REQUEST = {
            servicio_id: servicioId,
            funcion_id: moduloId,
          };
          const RESPONSE = await axios.post('clinic/servicio_complementario/insumos', REQUEST);
          util.showNotify(RESPONSE.data.message, 'success');
          this.getData();
        }
      } catch (error) {
        const FALLO_VALIDACION = 422;
        if (error.response.status !== FALLO_VALIDACION) {
          util.showNotify(error.response.data.message, 'error');
        } else {
          Object.entries(error.response.data.data).forEach(([, mensajes]) => {
            mensajes.forEach((texto) => util.showNotify(texto, 'error'));
          });
        }
      } finally {
        this.isDisabledSaveServicesMassively = false;
      }
    },
    existeEnTabla(servicioId, moduloId) {
      return this.listaTabla.some((item) => {
        let itemServicioId = null;
        if (item && item.servicio_id !== undefined && item.servicio_id !== null) {
          itemServicioId = item.servicio_id;
        } else if (item && item.tipo_servicio_id !== undefined && item.tipo_servicio_id !== null) {
          itemServicioId = item.tipo_servicio_id;
        } else if (item
          && item.servicio
          && item.servicio.id !== undefined
          && item.servicio.id !== null) {
          itemServicioId = item.servicio.id;
        }

        let itemModuloId = null;
        if (item && item.tipo_modulo_id !== undefined && item.tipo_modulo_id !== null) {
          itemModuloId = item.tipo_modulo_id;
        } else if (item && item.funcion_id !== undefined && item.funcion_id !== null) {
          itemModuloId = item.funcion_id;
        } else if (item && item.modulo_id !== undefined && item.modulo_id !== null) {
          itemModuloId = item.modulo_id;
        }

        return itemServicioId === servicioId && itemModuloId === moduloId;
      });
    },
    validar() {
      let valido = true;
      if (!this.ordenSeleccionada) {
        util.showNotify('Seleccione un tipo de orden', 'warn');
        valido = false;
      }
      if (!this.opcionSeleccionada) {
        util.showNotify('Seleccione un servicio', 'warn');
        valido = false;
      }
      return valido;
    },
    async saveActivarDesactivarUI() {
      this.isDisabled = true;
      this.activar = true;
    },
    // eslint-disable-next-line no-empty-function
    async guardarParametroNombre() {
    },
    async eliminarOpcion(item) {
      try {
        const RESPONSE = await axios.delete(`/clinic/servicio_complementario/insumos/${item.id}`);
        util.showNotify(RESPONSE.data.message, 'success');
        this.getData();
      } catch (error) {
        util.showNotify(error.response.data.message, 'error');
      }
    },
    onFileSelected(event) {
      // eslint-disable-next-line prefer-destructuring
      this.archivoSeleccionado = event.target.files[0];
      if (this.archivoSeleccionado) {
        util.showNotify(`Archivo "${this.archivoSeleccionado.name}" seleccionado`, 'success');
      }
    },
    async guardarCuentaContable() {
      try {
        if (!this.cuentaSelected) {
          util.showNotify('Por favor seleccione una cuenta contable', 'warn');
          return;
        }

        const requestData = {
          id: this.texto_activacion.id,
          cuenta_contable_insumo_id: this.cuentaSelected.id,
        };

        const response = await axios.post('/clinic/servicio_complementario/store_cuenta_contable_insumo', requestData);
        util.showNotify(response.data.message || 'Cuenta contable guardada exitosamente', 'success');

        // Opcional: limpiar la selección después de guardar
        // this.cuentaSelected = null;
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Error al guardar la cuenta contable';
        util.showNotify(errorMessage, 'error');
      }
    },
    async abrirModalAsginacionOT(item) {
      this.productoSeleccionado = item;
      const RESULT_OK = await this.editAsignacionOt(item.id);
      if (RESULT_OK) {
        this.$bvModal.show('asignar-orden-modal');
      }
    },
    ...mapActions('theModalAsignacionOT', [
      'editAsignacionOt',
      'resetModalAsignacionOT',
    ]),
    onModalAsignacion(data) {
      if (data) {
        this.getData();
      }
    },
    nombreButtonAsignacion(item) {
      return item.asignacion_orden_trabajo > 0 ? 'Asignado' : 'Sin Asignar';
    },
  },
  computed: {
    ...mapFields('theModalAsignacionOT', ['opciones']),
    tipoOrdenTrabajo() {
      return FUNCIONALIDADES.ORDEN_TRABAJO;
    },
  },
  beforeDestroy() {
    this.resetModalAsignacionOT();
  },
};
</script>
<style>
.btn-gray {
  background: rgb(206, 200, 200);
}

/* Estilos para multiselect */
.multiselect-servicios ::v-deep .multiselect {
  font-size: 14px;
}

.multiselect-servicios ::v-deep .multiselect__input {
  font-size: 14px;
}

.multiselect-servicios ::v-deep .multiselect__option {
  font-size: 14px;
  padding: 8px 12px;
}

.multiselect-servicios ::v-deep .multiselect__single {
  font-size: 12px;
}

.multiselect-orden ::v-deep .multiselect {
  font-size: 14px;
}

.multiselect-orden ::v-deep .multiselect__input {
  font-size: 14px;
}

.multiselect-orden ::v-deep .multiselect__option {
  font-size: 14px;
  padding: 8px 12px;
}

.multiselect-orden ::v-deep .multiselect__single {
  font-size: 14px;
}

.multiselect-cuenta ::v-deep .multiselect {
  font-size: 14px;
}

.multiselect-cuenta ::v-deep .multiselect__input {
  font-size: 14px;
}

.multiselect-cuenta ::v-deep .multiselect__option {
  font-size: 14px;
  padding: 8px 12px;
}

.multiselect-cuenta ::v-deep .multiselect__single {
  font-size: 14px;
}
</style>
